import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, CircularProgress, Button, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const CentralImportDialog = ({ open, title, message, detail, actionLabel }) => {
  const { t } = useTranslation("products");
  const effectiveTitle =
    title || t("centralImport.titleDefault");
  const effectiveMessage =
    message || t("centralImport.messageDefault");
  const effectiveActionLabel = actionLabel || t("centralImport.actionLabelDefault");

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>{effectiveTitle}</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
          <CircularProgress size={24} sx={{ mt: 0.5, flexShrink: 0 }} />
          <Box>
            <Typography>{effectiveMessage}</Typography>
            {detail ? (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {detail}
              </Typography>
            ) : null}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button disabled>{effectiveActionLabel}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CentralImportDialog;
